import * as React from "react";
import { Component } from "react";
import MainLayout from "../../layouts/MainLayout";
import Table from "../../components/Table";
import { __, getLocalized, getURLParam, mapStateToProps, setTableParams } from "../../core/utils";
import {createSidebar, createSuperadminSidebar} from "../../redux/actions/general/sidebar";
import { listActiveModules } from "../../redux/actions/general/active_modules";
import Tooltip from "../../components/Tooltip";
import * as _ from "lodash";
import { setPlusActions } from "../../redux/actions/general/plus";
import DeleteIcon from "../../assets/images/delete-15x15.svg";
import { hideAlertbox, showAlertbox } from "../../redux/actions/general/alertbox";
import { setNotification } from "../../redux/actions/general/notification";
import { listLocalization } from "../../redux/actions/localization";
import {
	deleteProductAttributeTemplateGroups,
	listProductAttributeTemplateGroups,
	readProductAttributeTemplateGroup
} from "../../redux/actions/table/superadmin/product_attribute_template_groups";
import ProductAttributeTemplateGroupsFlyout
	from "../../flyouts/superadmin/product_attribute_template_groups/ProductAttributeTemplateGroupsFlyout";

@mapStateToProps(state => ({
	superadmin: state.auth.superadmin,
	table: state.table["superadmin_product_attribute_template_groups"],
	auth: state.auth,
}))
class ProductAttributeTemplateGroups extends Component {
	constructor(props) {
		super(props);

		this.state = {
			preview: null,
		};
	}

	componentDidMount() {
		listActiveModules();
		createSuperadminSidebar(); //don't forget to add new routes in sidebar.js

		const { superadmin } = this.props;

		superadmin.add_product_attribute_template_group && setPlusActions([{
			title: "Add product attribute template group",
			onClick: () => setTableParams('superadmin_product_attribute_template_groups', {
				add_product_attribute_template_group_wizard: true
			})
		}]);
	}

	componentDidUpdate(prevProps) {
		if (this.props.table.clicked_row && this.props.table.clicked_row !== prevProps.table.clicked_row) {
			if (!prevProps.table.clicked_row) {
				this.setState({ preview: undefined });
			}

			readProductAttributeTemplateGroup(this.props.table.clicked_row).then(({ response }) => {
				this.setState({ preview: response.data });
			});
		}
	}

	render() {
		const { superadmin } = this.props;

		let columns = [
			{
				key: "name",
				name: "Name",
				required: true,
				sortable: false,
				value: name => (
					<Tooltip text={name}>{name}</Tooltip>
				)
			},
			{
				key: "priority",
				name: "Priority",
				width: 60				
			}
		];

		const singleActions = (product_attribute_template_group_id) => {
			return [
				<Tooltip text="Delete selected product attribute template group" key={_.uniqueId()}>
					<DeleteIcon
						onClick={e => {
							e.stopPropagation();

							showAlertbox({
								color: "red",
								title: __('general.alert.are-you-sure'),
								description: "Do you really want to delete the selected product attribute template group?\nThis process cannot be undone.",
								buttons: [
									{
										color: 'lightGray',
										text: __('general.alert.no-close'),
										onClick: 'close'
									},
									{
										color: 'gray',
										text: __('general.alert.yes-delete'),
										onClick: () => {
											deleteProductAttributeTemplateGroups([product_attribute_template_group_id]).then(() => {
												hideAlertbox();

												setNotification("The selected product attribute template group has been deleted.");
												listProductAttributeTemplateGroups();

												listLocalization();

												setTableParams('superadmin_product_attribute_template_groups', {
													actioned_row: undefined
												});
											});
										},
									}
								]
							})
						}}
					/>
				</Tooltip>
			];
		};

		const groupActions = (product_attribute_template_group_ids) => [
			<Tooltip text="Delete selected product attribute template groups" key={_.uniqueId()}>
				<DeleteIcon
					onClick={e => {
						e.stopPropagation();

						showAlertbox({
							color: "red",
							title: __('general.alert.are-you-sure'),
							description: "Do you really want to delete these product attribute template groups?\nThis process cannot be undone.",
							buttons: [
								{
									color: 'lightGray',
									text: __('general.alert.no-close'),
									onClick: 'close'
								},
								{
									color: 'gray',
									text: __('general.alert.yes-delete'),
									onClick: () => {
										deleteProductAttributeTemplateGroups(product_attribute_template_group_ids).then(() => {
											hideAlertbox();

											setNotification("The selected product attribute template groups have been deleted.");
											listProductAttributeTemplateGroups();

											listLocalization();

											setTableParams('superadmin_product_attribute_template_groups', {
												selected_rows: []
											});
										});
									},
								}
							]
						})
					}}
				/>
			</Tooltip>
		];

		const preview = (
			<ProductAttributeTemplateGroupsFlyout
				data={this.state.preview}
				readAction={product_attribute_template_group_id => {
					return new Promise(resolve => {
						readProductAttributeTemplateGroup(getURLParam('id') || product_attribute_template_group_id).then(({ response }) => {
							this.setState({ preview: response.data });

							resolve(response);
						});
					});
				}}
			/>
		);

		return (
			<Table
				listAction={listProductAttributeTemplateGroups}
				name="superadmin_product_attribute_template_groups"
				groupActions={superadmin.delete_product_attribute_template_group && groupActions}
				singleActions={superadmin.delete_product_attribute_template_group && singleActions}
				title={__("modules.submodules.title.product-attribute-template-groups")}
				preview={this.state.preview ? preview : []}
				columns={columns}
			/>
		);
	}
}

export default ProductAttributeTemplateGroups;
